import { render, staticRenderFns } from "./simples-fiscalizacao.vue?vue&type=template&id=1b78ebc0&scoped=true&"
import script from "./simples-fiscalizacao.vue?vue&type=script&lang=js&"
export * from "./simples-fiscalizacao.vue?vue&type=script&lang=js&"
import style0 from "./simples-fiscalizacao.vue?vue&type=style&index=0&id=1b78ebc0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b78ebc0",
  null
  
)

export default component.exports